// extracted by mini-css-extract-plugin
export default {"info-notice-content":"styles_info-notice-content__ymkvv"};